<template>
	<div class="wrapper questionare">
		<div class="upper">
			<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo"/>
			<h2>{{ t('txt_hello') }},</h2>
			<h1>{{ name }} {{ surname }}</h1>
			<avatar-selector :avatars="avatars" v-model="selectedAvatar" />
			<p>{{ t('txt_tellus_about') }}</p>
			<form ref="questionare" id="questionare" @submit.prevent="submitForm">
				<div class="custom-select-wrapper" id="country">
					<div class="custom-select">
						<select id="countryPicker" ref="countrySelect" v-model="selectedCountry" class="styled-select" name="country_iso_code">
							<option disabled value="">{{  t('txt_my_country') }}</option>
							<option v-for="country in countries" :key="country.iso_code" :value="country.iso_code">
								{{ country.native_name }}
							</option>
							<option value="OTH">{{  t('txt_other_countries') }}</option>
						</select>
						<span class="custom-badge">
							<span class="custom-count">70</span>
							<span class="custom-icon"><img src="../assets/img/spark.svg"></span>
						</span>
						<!-- <span class="custom-arrow"><img src="../assets/img/dropdown.svg"></span> -->
					</div>
				</div>
			</form>
		</div>
		<div class="bottom">
			<button type="submit" class="green" form="questionare">{{ t('txt_start_jurney')}}</button>
		</div>
	</div>
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import AvatarSelector from '../components/AvatarSelector.vue';
import apiClient from '../utils/axios';

export default {
	name: 'QuestionarePage',
	components: {
		AvatarSelector,
	},
	setup() {
		const { t, locale } = useI18n();
		const changeLanguage = (newLocale) => {
			locale.value = newLocale;
			localStorage.setItem('lang', newLocale);
		};
		return {
			changeLanguage,
			t
		};
	},
	data() {
		return {
			countries: null,
			selectedCountry: "",
			username: keycloak.tokenParsed?.preferred_username || 'User',
			name: keycloak.tokenParsed?.given_name || 'Name',
			surname: keycloak.tokenParsed?.family_name || 'Surname',
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'fox' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			],
			selectedAvatar: null,
		};
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			this.fetchUserData();
		}
		this.fetchCountries();
	},
	methods: {
		async fetchCountries() {
			try {
				const response = await apiClient.get('/'+localStorage.getItem('lang')+'/api/countries');
				this.countries = response.data;
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		},
		/* focusSelect() {
			var CountrySelect = document.getElementById('countryPicker');
			CountrySelect.showPicker();
		}, */
		fetchUserData(){
			const userData = {
				username: keycloak.tokenParsed.preferred_username,
				last_name: keycloak.tokenParsed?.family_name || 'Surname',
				first_name: keycloak.tokenParsed?.given_name || 'Name',
				email: keycloak.tokenParsed.email,
				keycloak_id: keycloak.tokenParsed.sub
			};
			apiClient.post('/'+localStorage.getItem('lang')+'/api/user', userData)
				.then(response => {
					this.userData = response.data;
					this.selectedAvatar = this.userData.avatar;
					const selected = this.avatars.find(avatar => avatar.id === this.userData.avatar);
					this.selectedAvatar = selected ? selected.id : this.avatars[0]?.id || null;
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
				});
		},
		submitForm() {
			const form = this.$refs.questionare;
			const formData = new FormData(form);
			const animationList = ['animate__animated','animate__shakeX'];
			const userData = {
				'country_iso_code': formData.get('country_iso_code'),
				'keycloak_id': keycloak.tokenParsed.sub
			}
			if(formData.get('country_iso_code') == null){
				let country = document.getElementById('country');
				country.classList.add(...animationList);
				this.removeAnimate(country,animationList);
			} else {
			apiClient.post('/'+localStorage.getItem('lang')+'/api/user/update', userData)
				.then(response => {
					if(response.data.country_iso_code != null){
						this.$router.push('/profile');
					} else {
						let country = document.getElementById('country');
						country.classList.add(...animationList);
						this.removeAnimate(country,animationList);
					}
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
				});
			}
		},
		removeAnimate(element,classes){
			setTimeout(() => {
				classes.forEach((classname) => {
					element.classList.remove(classname);
				});
			}, 500);
		}
	},
};
</script>

<style>

</style>
